import { getCurrentHoliday, getHolidayHomeWorkList } from '@/api/holiday'
import { getOssBookList, getOssHolidayBookJSON } from '@/api/ossBook'
import { transformOssbookDictionary } from '@/static/js/business'

export default {
  namespaced: true,
  state: {
    isStartHolidayShow: '',
    currentHoliday: {
      batch: '',
      category: '',
      name: ''
    },
    holidayBookList: {},
    holidayHomeWorkList: [],
    holidayBookInfo: {}
  },
  mutations: {
    commit_setHolidayShow(state, payload) {
      state.isStartHolidayShow = payload
    },
    commit_setCurrentHoliday(state, payload) {
      state.currentHoliday = payload
    },
    commit_setHolidayBookList(state, payload) {
      state.holidayBookList = {
        ...state.holidayBookList,
        [payload.grade]: payload.data
      }
    },
    commit_setHolidayHomeWorkList(state, data) {
      state.holidayHomeWorkList = data
    },
    commit_setHolidayBookInfo(state, payload) {
      state.holidayBookInfo = {
        ...state.holidayBookInfo,
        [payload.id]: payload.data
      }
    }
  },
  actions: {
    // 获取当前学期
    async dispatch_getCurrentHoliday({ state, commit }) {
      const { isStartHolidayShow, currentHoliday } = state
      if (isStartHolidayShow !== '') {
        return isStartHolidayShow && currentHoliday
      }
      const res = await getCurrentHoliday()
      if (res.data.batch) {
        commit('commit_setHolidayShow', true)
        commit('commit_setCurrentHoliday', res.data)
        return res.data
      } else {
        commit('commit_setHolidayShow', false)
        commit('commit_setCurrentHoliday', {})
        return false
      }
    },
    // 获取假期作业书籍列表
    async dispatch_getHolidayBookList({ state, commit, rootGetters, dispatch }, payload) {
      const grade = rootGetters.userGrade
      const stateData = state.holidayBookList[grade] || []
      // 已获取且年级/类型相同，则立即返回
      if (stateData && stateData.length > 0) {
        return stateData
      }
      const holiday = await dispatch('dispatch_getCurrentHoliday')
      // 假期未开启
      if (!holiday) {
        return stateData
      }
      // 获取书籍列表
      const category = holiday.category
      let bookList = await getOssBookList({}, [
        ['category', '=', category, true],
        ['grade', '=', grade, true]
      ])
      bookList = [...bookList]
      bookList.forEach((i) => {
        // 为了获取年级名称
        i.grades = [i.grade]
      })
      const transBookList = await transformOssbookDictionary(bookList)
      console.log(transBookList)
      commit('commit_setHolidayBookList', { data: transBookList, grade })
      return transBookList
    },
    // 根据isbn获取页面数据
    async dispatch_getHolidayHomeWorkList({ state, commit }, data) {
      try {
        const res = await getHolidayHomeWorkList(data)
        if (res.status === 200) {
          const transBookList = await transformOssbookDictionary(res.data)
          commit('commit_setHolidayHomeWorkList', [
            ...transBookList,
          ])
        } else {
          commit('commit_setHolidayHomeWorkList', [])
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取单本书籍信息
    async dispatch_getHolidayBookInfo({ state, commit }, payload) {
      const { bookId } = payload
      const stateData = state.holidayBookInfo[bookId]
      if (stateData) {
        return stateData
      }
      const data = await getOssHolidayBookJSON(bookId)
      data.grades = [data.grade]
      const transBook = await transformOssbookDictionary(data)
      commit('commit_setHolidayBookInfo', {
        id: bookId,
        data: transBook
      })
      return transBook
    }
  }
}
